import { useSelector } from "react-redux";
import MainContainer from "components/common/MainContainer";
import PageHeader from "components/common/PageHeader";
import Filter from "components/common/Filter";
import CasesTable from "components/common/CasesTable";
import { FormattedMessage } from "react-intl";
import ExportMessage from "components/common/ExportMessage";
import { RootState } from "redux/reducers/rootReducer";
import BaseToggle from "components/common/BaseToggle";
import { useState, useEffect } from "react";
import { useHistory, useLocation } from "react-router-dom";
import { QUERY_PARAMS } from "constants/constants";

const generateHeaderText = (showOnlyMyCases: boolean) => {
  if (showOnlyMyCases) {
    return <FormattedMessage id="pageName.myReports" />;
  }
  return <FormattedMessage id="pageName.allReports" />;
};

const CombinedReports = () => {
  const history = useHistory();
  const location = useLocation();

  const queryParams = new URLSearchParams(location.search);

  const initialShowOnlyMyCases =
    queryParams.get(QUERY_PARAMS.SHOW_ONLY_MY_CASES) === "true";

  const [showOnlyMyCases, setShowOnlyMyCases] = useState(
    initialShowOnlyMyCases
  );

  useEffect(() => {
    if (!queryParams.has(QUERY_PARAMS.SHOW_ONLY_MY_CASES)) {
      queryParams.set(QUERY_PARAMS.SHOW_ONLY_MY_CASES, "false");
      history.replace({ search: queryParams.toString() });
    }
  }, []);

  useEffect(() => {
    if (
      queryParams.has(QUERY_PARAMS.SHOW_ONLY_MY_CASES) &&
      queryParams.get(QUERY_PARAMS.SHOW_ONLY_MY_CASES) !==
        showOnlyMyCases.toString()
    ) {
      const newParams = new URLSearchParams();
      newParams.set(
        QUERY_PARAMS.SHOW_ONLY_MY_CASES,
        showOnlyMyCases.toString()
      );
      history.replace({ search: newParams.toString() });
    }
  }, [showOnlyMyCases]);

  const loading = useSelector((state: RootState) => state.caseRelated.loading);

  const handleToggle = () => setShowOnlyMyCases((prev) => !prev);

  const propsToPass = {
    loading: loading,
    showOnlyMyCases: showOnlyMyCases,
  };

  const headerText = generateHeaderText(showOnlyMyCases);

  return (
    <MainContainer
      filter={<Filter key={location.search} />}
      pageTitle={
        <div className="combined-reports__title">
          <PageHeader header={headerText} />
          <BaseToggle
            id="toggleShowMyCases"
            isToggled={showOnlyMyCases}
            handleSubmit={handleToggle}
            text={<FormattedMessage id="filters.showMyCases" />}
          />
        </div>
      }
    >
      <CasesTable {...propsToPass} />
      <ExportMessage />
    </MainContainer>
  );
};

export default CombinedReports;
